//BadgesContextualVariations

import { Activity, AlertTriangle, Award, Bell, DollarSign, GitHub, Headphones, Heart, Link, Mail, Music, Settings } from "react-feather";

export const BADGES_DATA = [
  { text: "Use the", code: ".badge " },
  { text: "utility class to make more badges." },
];

export const BADGES_CONTEXT = [
  {
    text: "Primary",
    className: "badge-primary",
  },
  {
    text: "Secondary",
    className: "badge-secondary",
  },
  {
    text: "Success",
    className: "badge-success",
  },
  {
    text: "Info",
    className: "badge-info",
  },
  {
    text: "Warning",
    className: "badge-warning text-dark",
  },
  {
    text: "Danger",
    className: "badge-danger",
  },
  {
    text: "Light",
    className: "badge-dark",
  },
  {
    text: "Dark",
    className: "badge-dark tag-pills-sm-mb",
  },
];

//Pills Contextual Variations

export const PILLS_DATA = [
    { text: "Use the", code: ".rounded-pill" },
    { text: " utility class to make badges more rounded with a larger " ,code:"border-radius."},
  ];

  export const PILLS_CONTEXT = [
    {
      text: "Primary",
      className: "rounded-pill badge-primary",
    },
    {
      text: "Secondary",
      className: "rounded-pill badge-secondary",
    },
    {
      text: "Success",
      className: "rounded-pill badge-success",
    },
    {
      text: "Info",
      className: "rounded-pill badge-info",
    },
    {
      text: "Warning",
      className: "rounded-pill badge-warning text-dark",
    },
    {
      text: "Danger",
      className: "rounded-pill badge-danger",
    },
    {
      text: "Light",
      className: "rounded-pill badge-dark",
    },
    {
      text: "Dark",
      className: "rounded-pill badge-dark tag-pills-sm-mb",
    },
  ];

//Number of Badge
export const NUMBER_DATA = [
    { text: "Use the", code: ".badge" },
    { text: " utility class to make number of more badges."},
  ];

  export const NUMBER_CONTEXT = [
    {
      text: "1",
      className: "badge-primary",
    },
    {
      text: "2",
      className: "badge-secondary",
    },
    {
      text: "3",
      className: "badge-success",
    },
    {
      text: "4",
      className: "badge-info",
    },
    {
      text: "5",
      className: "badge-warning text-dark",
    },
    {
      text: "6",
      className: "badge-danger",
    },
    {
      text: "7",
      className: "badge-light text-dark",
    },
    {
      text: "8",
      className: "badge-dark",
    },
  ];

//Number of Pills Tags
export const ROUNDED_DATA = [
  { text: "Use the", code: ".rounded-circle" },
  { text: " utility class to make badges more rounded with a larger",code:"border-radius."},
]

export const ROUNDED_CONTEXT = [
  {
    text: "1",
    className: "rounded-circle badge-p-space badge-primary",
  },
  {
    text: "2",
    className: "rounded-circle badge-p-space badge-secondary",
  },
  {
    text: "3",
    className: "rounded-circle badge-p-space badge-success",
  },
  {
    text: "4",
    className: "rounded-circle badge-p-space badge-info",
  },
  {
    text: "5",
    className: "rounded-circle badge-p-space badge-warning text-dark",
  },
  {
    text: "6",
    className: "rounded-circle badge-p-space badge-danger",
  },
  {
    text: "7",
    className: "rounded-circle badge-p-space badge-light text-dark",
  },
  {
    text: "8",
    className: "rounded-circle badge-p-space badge-dark",
  },
];

// Badge Tags With Icons
export const ICON_DATA = [
  { text: "Use the", code: ".badge " },
  { text: " utility class to make number of more icons."},
]

export const ICON_CONTEXT = [
  {
    className: "b-ln-height badge-primary",
    icon:<DollarSign/>,
  },
  {
    className: "b-ln-height badge-secondary",
    icon:<Headphones/>
  },
  {
    className: "b-ln-height badge-success",
    icon:<Link/>
  },
  {
    className: "b-ln-height badge-info",
    icon:<GitHub/>
  },
  {
    className: "b-ln-height badge-warning text-dark",
    icon:<Award/>
  },
  {
    className: "b-ln-height badge-danger",
    icon:<Activity/>
  },
  {
    className: "b-ln-height badge-light text-dark",
    icon:<Heart/>
  },
  {
    className: "b-ln-height badge-dark",
    icon:<Mail/>
  },
];

// Rounded Pills With Icons
export const ROUNDED_PILLS_DATA = [
  { text: "Use the", code: ".rounded-pill" },
  { text: " utility class to make icons badges more rounded with a larger ",code:"border-radius."},
]

export const ROUNDED_PILLS_CONTEXT = [
  {
    className: "rounded-circle p-2 badge-primary",
    icon:<DollarSign/>,
  },
  {
    className: "rounded-circle p-2 badge-secondary",
    icon:<Headphones/>
  },
  {
    className: "rounded-circle p-2 badge-success",
    icon:<Link/>
  },
  {
    className: "rounded-circle p-2 badge-info",
    icon:<GitHub/>
  },
  {
    className: "rounded-circle p-2 badge-warning text-dark",
    icon:<Award/>
  },
  {
    className: "rounded-circle p-2 badge-danger",
    icon:<Activity/>
  },
  {
    className: "rounded-circle p-2 badge-light text-dark",
    icon:<Heart/>
  },
  {
    className: "rounded-circle p-2 badge-dark",
    icon:<Mail/>
  },
];

//Badge Headings Example
export const BADGE_EX_DATA = [
  { text: "All html headings,", code: "<h1>" },
  { text: "through ",code:"<h6>"},
  { text: ", are available in ",code:".badge "},
  { text: "tags."},
]

//Badges As Part Buttons
export const BADGE_BUTTON_DATA = [
  { code: ".badge" },
  { text: " can be used as part of <code>.btn</code> to provide a icons."},
]

export const BADGE_BUTTON_LIST = [
  { 
    className: "secondary",
    title: "notifications",
    icon:<Bell/>
   },
   { 
    className: "success",
    title: "Update available",
    icon:<Settings/>
   },{ 
    className: "info",
    title: "Playing Now",
    icon:<Music/>
   },{ 
    className: "warning",
    title: "1.2 GB Used",
    icon:<AlertTriangle/>
   },
]